document.addEventListener("DOMContentLoaded", () => {
    let doc = document;
    let sliders = doc.querySelectorAll('.colors');
    sliders.forEach((slider) => {
        let objectSlider = new ColorGroupSlider(slider);
        objectSlider.init();
    });
});

class ColorGroupSlider {
    constructor(slider) {
        this.slider = slider;
        this.items = slider.querySelectorAll('li');
        this.index = 0;
        this.animate = false;
    }

    init() {
        this.bindArrows();
    }

    slide(direction) {
        if (this.animate) {
            return;
        }
        let slideCount = Math.ceil(this.items.length / 4);
        if (window.innerWidth > 450) {
            slideCount = Math.ceil(this.items.length / 8);
        }

        this.animate = true;

        if (direction == 'left') {
            this.index = (this.index - 1) < 0 ? slideCount - 1 : (this.index - 1);
        } else if (direction == 'right') {
            this.index = (this.index + 1) > slideCount - 1 ? 0 : (this.index + 1);
        }

        this.slider.querySelector('.colors__wrap ul').style.marginLeft = (this.index * -100) + '%';

        let that = this;
        setTimeout(function () {
            that.animate = false;
        }, 150);
    }

    addImageClasses(item, classesData) {
        let images = item.querySelectorAll('.text-image-content__image');
        images.forEach(function (node) {
            node.classList.add(...classesData);
        })
    }

    removeImageClasses(item, classesData) {
        let images = item.querySelectorAll('.text-image-content__image');
        images.forEach(function (node) {
            node.classList.remove(...classesData);
        })
    }

    bindArrows() {
        let buttons = this.slider.querySelectorAll('.colors__buttons');
        buttons.forEach((buttonContainer) => {
            let leftArrow = buttonContainer.querySelector('.left');
            let rightArrow = buttonContainer.querySelector('.right');

            leftArrow.addEventListener('click', () => {
                this.slide('left');
            });
            rightArrow.addEventListener('click', () => {
                this.slide('right');
            });

        })
    }
}
